enum OloCustomKeyOrderField {
  GuestPhoneNumber = 'guestPhoneNumber',
  GuestEmail = 'guestEmail',
  TableNumber = 'tableNumber',
  IsI9nFutureOrder = 'isI9nFutureOrder',
  GuestVehicleMake = 'guestVehicle.make',
  GuestVehicleModel = 'guestVehicle.model',
  GuestVehicleColor = 'guestVehicle.color',
  LoyaltyCustomerId = 'loyaltyAuthData.customerId',
  EmptyValue = 'emptyValue', // In the case that the org just wants the label to show up but not the value
  TemplateString = 'templateString',
}

export { OloCustomKeyOrderField };
